// lib/apolloClient.ts
import { ApolloClient, createHttpLink, InMemoryCache } from '@apollo/client'
import { setContext } from '@apollo/client/link/context'
import { onError } from '@apollo/client/link/error'

import type { DefaultOptions } from '@apollo/client'

export const GRAPHQL_URL =
  process.env.NEXT_PUBLIC_GRAPHQL_URL || 'https://som.danester.com/graphql'

const httpLink = createHttpLink({
  uri: GRAPHQL_URL,
  fetchOptions: {
    cache: 'no-store'
  }
})

const authLink = setContext((operation, { headers }) => {
  const token = localStorage.getItem('token')

  // Skip auth for login operation
  if (operation.operationName === 'LoginUser') {
    return { headers }
  }

  const authorization = headers?.authorization || `Bearer ${token}`

  return {
    headers: {
      ...headers,
      authorization
    }
  }
})

const redirectToLogin = () => {
  if (typeof window === 'undefined') return
  if (window.location.pathname === '/login') return
  localStorage.removeItem('token')
  window.location.href = '/login'
}

const errorLink = onError(({ graphQLErrors, networkError }) => {
  const statusCode = (networkError as { statusCode?: number } | undefined)
    ?.statusCode
  if (statusCode === 401) {
    redirectToLogin()
    return
  }

  if (graphQLErrors?.some(err => err.extensions?.code === 'UNAUTHENTICATED')) {
    redirectToLogin()
  }
})

const defaultOptions: DefaultOptions = {
  watchQuery: {
    fetchPolicy: 'cache-and-network',
    nextFetchPolicy: 'cache-first'
  },
  query: {
    fetchPolicy: 'network-only'
  },
  mutate: {
    errorPolicy: 'all'
  }
}

const client = new ApolloClient({
  link: errorLink.concat(authLink.concat(httpLink)),
  cache: new InMemoryCache({
    typePolicies: {
      Slide: { keyFields: ['slideId'] },
      MediaItem: { keyFields: ['mediaItemId'] },
      Customer: { keyFields: ['customerId'] },
      Location: { keyFields: ['locationId'] },
      Device: { keyFields: ['deviceId'] },
      Slideshow: { keyFields: ['slideshowId'] },
      Schedule: { keyFields: ['id'] },
      User: { keyFields: ['userName'] }
    }
  }),
  defaultOptions
})

export default client
